import { createContext } from 'react';
import type { SiteData } from '../../types/siteData.types';

/**
 * Without adding the complexity of Redux we can use this Context to pass things like locale/langCodes and
 * other useful siteConfig based values into components that are nested deep,
 * avoiding passing the values down through prop hell.
 */

const SiteContext = createContext<SiteData | undefined>(undefined);

export const SiteProvider = SiteContext.Provider;
export const SiteConsumer = SiteContext.Consumer;

export default SiteContext;
